import { Playground } from "docz";
import { Hobby } from "../../../../src/components/Hobby";
import * as React from 'react';
export default {
  Playground,
  Hobby,
  React
};